module.exports = __webpack_public_path__ + "img/xwzx.a9ab9ba3.png";